import { render } from "./Event.vue?vue&type=template&id=7d3b1c4c&bindings={\"eventname\":\"data\",\"oldTab\":\"data\",\"transition\":\"data\"}"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script